import gql from 'graphql-tag';
import {History} from 'history';

export const ACTIVE_TRANSPORTER_PARAM = 'activeTransporterID';

export const SELECT_TRANSPORTER = gql`
    mutation SelectActiveTransporter($id: ID!) {
        transporter(id: $id) @client {
            _id
            name
        }
    }
`;

/** Preserve the destination, other guidance parameters, hash and navigation state. */
export function clearActiveTransporterParameter(history: History) {
    const params = new URLSearchParams(history.location.search);
    if (!params.has(ACTIVE_TRANSPORTER_PARAM)) return;

    params.delete(ACTIVE_TRANSPORTER_PARAM);
    const search = params.toString();
    history.replace({...history.location, search: search ? `?${search}` : ''});
}
